var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2327"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2674",
    d: "M 10,0 C 4.4890018,0 0,4.4890018 0,10 0,15.510998 4.4890018,20 10,20 15.510998,20 20,15.510998 20,10 20,4.4890018 15.510998,0 10,0 Z m 0,2 c 4.430216,0 8,3.5697836 8,8 0,4.430216 -3.569784,8 -8,8 C 5.5697836,18 2,14.430216 2,10 2,5.5697836 5.5697836,2 10,2 Z m 0,13.5 c 3.025,0 5.5,-2.475 5.5,-5.5 0,-3.025 -2.475,-5.5 -5.5,-5.5 -3.0250002,0 -5.5,2.475 -5.5,5.5 0,3.025 2.4749998,5.5 5.5,5.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChecked);
export default __webpack_public_path__ + "static/media/circleChecked.e2a044a3.svg";
export { ForwardRef as ReactComponent };